import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from 'react-bootstrap';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import { handleChangeDataSearchBranchAutoComplete } from '../../../../redux/actions/partials/search/searchBranch';
import CardShopBranch from '../transfer/cardShopBranch';

const SelectBranch = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { shop, branches } = useSelector(state => state.selectBranch);

    const handleBackBtn = () => {
        navigate(-1);
    };



    return (

        <div id="login-page">
            <Row className="pt-5">
                <Col xs={1} className="d-flex align-items-center"><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10} className="text-center">
                    <div className="header_h3">
                        شما در حال انتقال وجه به <strong>{shop.title ?? ''}</strong> هستید
                    </div>
                </Col>
                <Col xs={1}></Col>
                <Col xs={12} className="header_h4 font-weight-300 text-center mt-1">
                    لطفا شعبه مورد نظر را انتخاب کنید
                </Col>
            </Row>

            <Row className="mt-4">
                {
                    branches.map((branch, key) => {
                        let item = {
                            id: shop.id, 
                            title: shop.title, 
                            branch_id: branch.branchId, 
                            branch_title: branch.branchTitle, 
                            cash_back: branch.cash_back, 
                            logo: branch.logo, 
                            services: branch.services
                        };
                        return (
                            <Col key={key}>
                                <CardShopBranch data={{item}} />
                            </Col>
                        );
                    })
                }
                        
            </Row>

        

        </div>

    );
}

export default SelectBranch;